import { Injectable, inject } from '@angular/core';
import { Observable, filter, tap } from 'rxjs';
import { GeoblockingService } from './geoblocking.service';
import { ResourceFacade } from '~backoffice/app/~store/facades/resource.facade';
import { GlobalFacade } from '~backoffice/app/~store/facades/global.facade';
import { SnackbarService } from '~backoffice/app/~shared/services/snackbar.service';
import { GeoblockingTimeSlice } from '~core/models/core.models';
import { DeleteConfirmComponent } from '~backoffice/app/~shared/components/modals/delete-confirm/delete-confirm.component';
import { GeoblockingFormComponent } from '~backoffice/app/settings/modals/geoblocking-form/geoblocking-form.component';
import { DialogService } from '~core/services/dialog.service';

@Injectable()
export class GeoblockingManagementService {
  private resourceFacade = inject(ResourceFacade);
  private geoblockingService = inject(GeoblockingService);
  private globalFacade = inject(GlobalFacade);

  constructor(
    private snackBar: SnackbarService,
    private dialogService: DialogService
  ) {}

  edit(geoblockingTimeSlice?: GeoblockingTimeSlice): Observable<unknown> {
    this.globalFacade.setFormViolations([]);
    const dialogRef = this.dialogService.open({
      component: GeoblockingFormComponent,
      config: {
        panelClass: ['mat-dialog-custom-full-screen'],
        disableClose: true,
        height: '100vh',
        width: '100vw',
        maxWidth: '100vw'
      }
    });

    dialogRef.componentInstance.geoblocking = geoblockingTimeSlice;
    return dialogRef.afterClosed();
  }

  delete(geoblockingTimeSlice: GeoblockingTimeSlice): Observable<unknown> {
    const delete$ = this.geoblockingService.delete(geoblockingTimeSlice.id);
    const dialogRef = this.dialogService.open({
      component: DeleteConfirmComponent,
      config: {
        panelClass: ['mat-dialog-custom'],
        disableClose: true
      }
    });

    dialogRef.componentRef?.setInput('removeObservable$', delete$);
    dialogRef.componentRef?.setInput(
      'title',
      'Voulez-vous supprimer ce Profil ?'
    );
    dialogRef.componentRef?.setInput(
      'wordEntry',
      geoblockingTimeSlice.accessControlName
    );

    return dialogRef.afterClosed().pipe(
      filter(Boolean),
      tap({
        next: () => {
          this.resourceFacade.getData({ refresh: true });
          this.snackBar.open({
            text: 'Profil supprimé',
            type: 'success'
          });
        }
      })
    );
  }
}
